import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { signOutAsync } from 'redux/auth/authActions';

const useSessionTimeout = (timeoutDuration = 20 * 60 * 1000) => { // 20 minutes in milliseconds
const dispatch = useDispatch();
  const timerRef = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, timeoutDuration);
  };

  const logout = () => {
    dispatch(signOutAsync());
  };

  useEffect(() => {
    resetTimer();
    const events = ['click', 'mousemove', 'keypress'];

    // Reset timer on user activity
    const resetTimerOnActivity = () => resetTimer();
    events.forEach(event => window.addEventListener(event, resetTimerOnActivity));
    return () => {
      clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimerOnActivity));
    };
  }, []);

  return null;
};

export default useSessionTimeout;
